import React from 'react';
import {Redirect} from 'react-router-dom';

import User from 'Services/User';

/**
 * @function CanManageServices
 * @param {*|JSX.Element} component
 * @return {*|JSX.Element}
 * @constructor
 */
const CanManageServices = ({component}) => {
    const canManage = User.loggedIn && User.data.service_access?.can_manage_services === true;

    return canManage ? component : <Redirect to="/login" />;
};

export default CanManageServices;
